/* ==========================================================================
   WAYPOINT — shared shimmer block for skeleton loaders shaped like content.
   ========================================================================== */

export function Shimmer({
  width = '100%',
  height = 16,
  radius = 8,
  style,
}: {
  width?: number | string;
  height?: number | string;
  radius?: number;
  style?: React.CSSProperties;
}) {
  return (
    <span
      className="wp-shimmer"
      style={{ width, height, borderRadius: radius, display: 'block', ...style }}
      aria-hidden="true"
    />
  );
}

export const SHIMMER_CSS = `
  .wp-shimmer {
    background: linear-gradient(90deg, var(--canvas-raised), var(--cloud), var(--canvas-raised));
    background-size: 200% 100%;
    animation: wp-shimmer-sweep 1.4s ease-in-out infinite;
  }
  @keyframes wp-shimmer-sweep { to { background-position: -200% 0; } }
`;
